import styled from 'styled-components';
import Colors from 'bit/mobiauto.web-ui-components.components.colors/colors';
import { withStyles } from '@material-ui/core/styles';
import { Switch } from '@material-ui/core';

export const Wrapper = styled.div`
  background: white;
  padding: 18px;
  height: 100%;
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(51, 51, 51, 0.1);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  .MuiDataGrid-colCellTitle {
    white-space: normal !important;
    line-height: normal;
  }
`;

export const OvalBigger = styled.div`
  min-width: 32px;
  min-height: 32px;
  background-color: ${Colors.gray.nearWhite};
  font-family: Poppins Bold;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${Colors.gray.dark};
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
  position: relative;
`;

export const StatusBadge = styled.div`
  position: absolute;
  background: ${({ online }) => (online ? '#02ce2e' : '#949292')};
  width: 10px;
  height: 10px;
  right: 0;
  bottom: 0;
  border-radius: 50%;
`;
export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 8px;
  line-height: 12px;
`;

export const MobiSwitch = withStyles({
  switchBase: {
    '&$checked': {
      color: '#00B0AA',
    },
    '&$checked + $track': {
      backgroundColor: '#00B0AA',
    },
  },
  checked: {},
  track: {},
})(Switch);
